import { useState, useEffect } from 'react';
import InputAdornment from '@mui/material/InputAdornment';
import TextField from '@mui/material/TextField';
import SearchIcon from '@mui/icons-material/Search';

import * as Styles from './Autocomplete.styles';

const Autocomplete = ({
  options,
  className,
  placeholder,
  id,
  onChange,
  onInputChange,
  noOptionsText = 'Không tìm thấy kết quả',
  variant = '',
}) => {
  const [value, setValue] = useState('');

  const handleChange = (event, newValue) => {
    setValue(newValue);
    if (onChange) {
      onChange(newValue);
    }
  };

  if (variant === 'input') {
    return (
      <Styles.AutocompleteStyle
        className={className}
        disablePortal
        id={id}
        options={options}
        value={value}
        onChange={handleChange}
        onInputChange={onInputChange}
        noOptionsText={noOptionsText}
        renderInput={(params) => (
          <TextField
            {...params}
            placeholder={placeholder}
            fullWidth
            InputProps={{
              ...params.InputProps,
            }}
          />
        )}
      />
    );
  }

  return (
    <Styles.AutocompleteStyle
      className={className}
      disablePortal
      id={id}
      options={options}
      value={value}
      onChange={handleChange}
      noOptionsText={noOptionsText}
      renderInput={(params) => (
        <TextField
          {...params}
          placeholder={placeholder}
          fullWidth
          InputProps={{
            ...params.InputProps,
            startAdornment: (
              <>
                <InputAdornment position="start">
                  <SearchIcon />
                </InputAdornment>
              </>
            ),
          }}
        />
      )}
    />
  );
};

export default Autocomplete;
